export const credits = {
    credits: "Credits",
    license: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    contact: "Contact Us",
}
